import { TicketStatus } from "../../aiTickets.types";
import { InlineDropdown } from "../InlineDropdown";
import { StatusPill } from "../StatusPill";

interface Props {
  status: TicketStatus;
  disabled?: boolean;
  onChange: (next: TicketStatus) => void;
}

const STATUS_OPTIONS: TicketStatus[] = [
  "Open",
  "Processing",
  "Resolved",
  "Closed",
];

const StatusCell = ({ status, disabled, onChange }: Props) => (
  <InlineDropdown<TicketStatus>
    value={status}
    disabled={disabled}
    onSelect={onChange}
    trigger={<StatusPill status={status} />}
    options={STATUS_OPTIONS.map((s) => ({
      value: s,
      label: <StatusPill status={s} withChevron={false} />,
    }))}
  />
);

export default StatusCell;
